// ContabilidadCalendario.js

import React, { useState } from 'react';
import { 
  Box, 
  Typography, 
  IconButton,
  Paper,
  Button
} from '@mui/material';
import { ChevronLeft, ChevronRight } from '@mui/icons-material';
import './ContabilidadCalendario.css';

const ContabilidadCalendario = ({ selectedDate, onDateChange }) => {
  const [currentDate, setCurrentDate] = useState(selectedDate || new Date());

  const monthNames = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", 
                     "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"];
  const dayNames = ["Lun", "Mar", "Mié", "Jue", "Vie", "Sáb", "Dom"];

  const changeMonth = (offset) => {
    const newDate = new Date(currentDate);
    newDate.setMonth(newDate.getMonth() + offset);
    setCurrentDate(newDate);
  };

  const goToToday = () => {
    const today = new Date();
    setCurrentDate(today);
    onDateChange && onDateChange(today);
  };

  const generateDays = () => {
    const year = currentDate.getFullYear();
    const month = currentDate.getMonth();
    
    const firstDay = new Date(year, month, 1);
    const lastDay = new Date(year, month + 1, 0);
    
    const startDay = (firstDay.getDay() + 6) % 7;
    const daysInMonth = lastDay.getDate();
    
    const days = [];
    for (let i = 0; i < startDay; i++) days.push(null);
    for (let i = 1; i <= daysInMonth; i++) days.push(i);
    return days;
  };

  const isCurrentDay = (day) => {
    const today = new Date();
    return (
      day &&
      currentDate.getMonth() === today.getMonth() &&
      currentDate.getFullYear() === today.getFullYear() &&
      day === today.getDate()
    );
  };

  const isSelectedDay = (day) => {
    if (!selectedDate) return false;
    return (
      day &&
      selectedDate.getDate() === day &&
      selectedDate.getMonth() === currentDate.getMonth() &&
      selectedDate.getFullYear() === currentDate.getFullYear()
    );
  };

  const handleDayClick = (day) => {
    if (!day) return;
    const newDate = new Date(currentDate.getFullYear(), currentDate.getMonth(), day);
    onDateChange && onDateChange(newDate);
  };

  return (
    <Box className="calendar-container">
      <Paper elevation={3} className="calendar-header">
        <IconButton onClick={() => changeMonth(-1)} className="nav-button">
          <ChevronLeft />
        </IconButton>
        
        <Typography variant="h5" className="month-title">
          {monthNames[currentDate.getMonth()]} {currentDate.getFullYear()}
        </Typography>
        
        <IconButton onClick={() => changeMonth(1)} className="nav-button">
          <ChevronRight />
        </IconButton>
        
        <Button 
          variant="contained" 
          onClick={goToToday}
          className="today-button"
        >
          Hoy
        </Button>
      </Paper>

      <div className="calendar-grid">
        {dayNames.map((day) => (
          <div key={day} className="day-header">
            {day}
          </div>
        ))}
        
        {generateDays().map((day, index) => (
          <div 
            key={index} 
            className={`day-cell 
              ${!day ? 'empty' : ''} 
              ${isCurrentDay(day) ? 'current-day' : ''}
              ${isSelectedDay(day) ? 'selected-day' : ''}`}
            onClick={() => handleDayClick(day)}
          >
            {day}
          </div>
        ))}
      </div>
    </Box>
  );
};

export default ContabilidadCalendario;
